import React from "react";

const steps = [
  {
    n: "01",
    title: "Tell Us Your Goals",
    body: "Complete a short form and share your investment criteria, budget, and preferred strategy.",
  },
  {
    n: "02",
    title: "We Source Your Deal",
    body: "Our team searches, vets, and stress-tests every opportunity against strict investment metrics.",
  },
  {
    n: "03",
    title: "Receive a Detailed Pack",
    body: "You receive a full property report: financials, comparables, area analysis, projected returns.",
  },
  {
    n: "04",
    title: "Complete With Confidence",
    body: "We support you through to completion, connecting you with our trusted network of solicitors, brokers, and agents.",
  },
];

export function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-[var(--navy)] text-[var(--ivory)] grain-overlay py-24 lg:py-32"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="reveal max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[var(--gold)]" />
            <span className="text-[0.7rem] tracking-[0.32em] uppercase text-[var(--gold)]">
              The Process
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.05]">
            How It Works
          </h2>
          <p className="mt-6 text-[var(--ivory)]/70 max-w-xl">
            A measured, transparent process — from your first conversation through to the day you collect the keys.
          </p>
        </div>

        <div className="relative mt-20">
          {/* Horizontal gold line desktop */}
          <div className="hidden lg:block absolute left-0 right-0 top-[28px] h-px bg-gradient-to-r from-transparent via-[rgba(201,168,76,0.4)] to-transparent" />
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-8">
            {steps.map((s, i) => (
              <div key={s.n} data-testid={`process-step-${i}`} className="reveal">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 rounded-full border border-[var(--gold)] bg-[var(--navy)] flex items-center justify-center font-display text-[1.2rem] text-[var(--gold)] relative z-10">
                    {s.n}
                  </div>
                  <div className="lg:hidden h-px flex-1 bg-[rgba(201,168,76,0.3)]" />
                </div>
                <h3 className="font-display text-[1.6rem] leading-tight">{s.title}</h3>
                <p className="mt-3 text-[0.95rem] text-[var(--ivory)]/70 leading-relaxed">
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
